<template>
  <AttachmentPreviewContainer
    type="Appointment"
    :title="`${attachment.data._servicesLabel} with ${attachment.data.employeesLabel}`"
    :info="attachment.data.dateLabel"
    icon="reservation"
    @remove="$emit('remove')"
  />
</template>

<script setup lang="ts">
import AttachmentPreviewContainer from '../../preview/Container.vue'

interface Props {
  attachment: Record<string, any>
}

defineProps<Props>()

const emit = defineEmits<{
  (e: 'remove'): void
}>()
</script>
